const config = {
  environment: import.meta.env.VITE_APP_ENVIRONMENT,

  urls: {
    baseUrl: import.meta.env.VITE_API_BASE_URL || (import.meta.env.DEV ? 'http://localhost:8000/v1/' : 'https://api.xecubes.com/v1/'),
    careerPageUrl: import.meta.env.VITE_CAREER_PAGE_URL,
    ipv4Check: import.meta.env.VITE_IPV4_CHECKER_URL,
    authUrl: import.meta.env.VITE_AUTH_URL,
    docsUrl: import.meta.env.VITE_DOCS_URL || (import.meta.env.DEV ? 'http://localhost:3000' : 'https://docs.xecubes.com'),
  },

  supabaseConfig: {
    url: import.meta.env.VITE_SUPABASE_URL,
    anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
  },

  sentryConfig: {
    dsn: import.meta.env.VITE_SENTRY_DSN,
  },

  supademo: {
    apiKey: import.meta.env.VITE_SUPADEMO_API_KEY,
    demos: {
      adminShowcase: 'cm3wm61nx0f4y10dn4gq1dsbw',
      managerShowcase: 'cm3wm5ky90f4n10dnit9xv35y',
      recruiterShowcase: 'cm3wm4zxe0f4c10dncuumsuyc',
    },
  },
  aiAssessment: import.meta.env.VITE_AI_ASSESSMENT,

  appSettings: {
    isProduction: import.meta.env.VITE_IS_PRODUCTION === 'true',
    isMaintenance: import.meta.env.VITE_APP_MAINTAINENCE,
    maintenanceMessage: import.meta.env.VITE_APP_MAINTAINENCE_MESSAGE,
    chromeExtensionId: import.meta.env.VITE_CHROME_EXTENSION_ID,
  },
  cloudflare: {
    turnstile_site_key: import.meta.env.VITE_TURNSTILE_SITE_KEY,
  },
  posthog: {
    apiKey: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
    apiHost: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  },
  enableGmail: import.meta.env.VITE_ENABLE_GMAIL,
  enableAutomation: import.meta.env.VITE_ENABLE_AUTOMATION,
}

export default config
